import { CircularProgress } from '@mui/material';
import { LoadingContainerStyled } from './loading.styled';

export const Loading = () => {
  return (
    <LoadingContainerStyled>
      <CircularProgress />
    </LoadingContainerStyled>
  );
};
